import './create.css';

import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { API } from '../actions/userAction';
import { URL } from '../constants/userConstants';
import { getrowClass } from '../utils/getrowclass';
import StatsName from './statsname';

const FURL = process.env.REACT_APP_FURL || ''; 

const columns = [
  {
    field: 'playerId',
    headerName: 'ID',
    width: 0,
    hide: true,
  },
  {
    field: 'playerName',
    headerName: 'PLAYERS',
    flex: 1,
    renderCell: (params) => {
      const player = params.row;

      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {/* LEFT SIDE */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={`${FURL}/${player.image}`}
              alt={player.playerName}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/player_logo.jpeg';
              }}
              style={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                objectFit: 'cover',
                marginRight: 12,
                border: '1px solid #eee',
              }}
            />

            <div>
              <div style={{ fontWeight: 600, fontSize: 14 }}>
                {player.playerName}
              </div>

              <div
                style={{
                  fontSize: 12,
                  color: '#888',
                  marginTop: 2,
                }}
              >
                {player.role || 'Player'}
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div
            style={{
              fontWeight: 600,
              fontSize: 16,
              color: '#222',
            }}
          >
            {player.points}
          </div>
        </div>
      );
    },
  },
  {
    field: 'points',
    headerName: 'POINTS',
    flex: 0.2,
  },
];

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  border: 'none',

  '& .MuiDataGrid-columnHeaders': {
    display: 'none',
  },

  '& .MuiDataGrid-cell': {
    borderBottom: '1px solid #f0f0f0',
  },

  '& .MuiDataGrid-row': {
    backgroundColor: '#fff',
  },

  [`& .${gridClasses.row}.even`]: {
    backgroundColor: '#eaffea',
  },

  [`& .${gridClasses.row}.prime`]: {
    backgroundColor: '#eaffea',
  },

  [`& .${gridClasses.row}.sikh`]: {
    backgroundColor: '#fff',
  },
}));

export function Stats({ matchdata, team }) {
  const [match, setMatch] = useState(null);
  const { id } = useParams();
  const [players, setPlayers] = useState([]);
  const [allPlayers, setAllplayers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dreamTeam, setDreamTeam] = useState([]);
  const [next, setNext] = useState(false);

  useEffect(() => {
    const all = [];
    if (team?.length > 0) {
      team.forEach((t) => {
        all.push(...t.players);
      });
    }
    setAllplayers([...all]);
  }, [team]);

  useEffect(() => {
    async function getupcoming() {
      if (id) {
        setLoading(true);
        const data = await API.get(`${URL}/getplayers/${id}`);
        setLoading(false);

        const playersdata = data.data.players.teamAwayPlayers
          .concat(data.data.players.teamHomePlayers)
          .map((obj) => ({
            ...obj,
            id: obj.playerId,
            isSelected: false,
          }));

        setPlayers([...playersdata]);

        setDreamTeam([
          ...playersdata.sort((a, b) => b.points - a.points).slice(0, 11),
        ]);

        setMatch(data.data.matchdetails);
      }
    }

    getupcoming();
  }, [id]);

  const handleClick = (i) => {
    const po = players.map((p) => {
      if (p._id === i) {
        p.isSelected = true;
      }
      return p;
    });
    setPlayers([...po]);
  };

  const handleRemove = (i) => {
    const po = players.map((p) => {
      if (p._id === i) {
        p.isSelected = false;
      }
      return p;
    });
    setPlayers([...po]);
  };

  const handleNext = () => {
    setNext(true);
  };

  return (
    <Box sx={{ height: 600, width: '100%' }}>
      <StripedDataGrid
        loading={loading}
        rows={players}
        columns={columns}
        disableRowSelectionOnClick
        getRowId={(row) => row.playerId}
        rowHeight={72}
        hideFooter
        initialState={{
          columns: {
            columnVisibilityModel: {
              playerId: false,
            },
          },
        }}
        getRowClassName={(params) =>
          getrowClass(allPlayers, dreamTeam, params.row.playerName)
        }
      />
    </Box>
  );
}

export default Stats;
